import { useEffect } from 'react';

import { scroller } from 'react-scroll';

import useMediaBreakpoints from 'hooks/useMediaBreakpoints';

import { LANDING_PAGES_CONTAINER_ID } from '../../../shared/LandingPage/components/Grid';

export function useScrollToNewDefaultAnchor(defaultAnchor) {
  const { isTabletOrMobile } = useMediaBreakpoints();

  useEffect(() => {
    if (!defaultAnchor) {
      return;
    }

    setTimeout(() => {
      scroller.scrollTo(defaultAnchor, { containerId: LANDING_PAGES_CONTAINER_ID });
    }, 500);
  }, [defaultAnchor, isTabletOrMobile]);

  return defaultAnchor;
}
